var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Toast } from './toast';
var ToastContext = React.createContext({
    openToast: function () { return undefined; },
    closeToast: function () { return undefined; },
});
export var ToastProvider = function (_a) {
    var children = _a.children;
    var _b = __read(React.useState(null), 2), toast = _b[0], setToast = _b[1];
    var _c = __read(React.useState(false), 2), isOpen = _c[0], setisOpen = _c[1];
    var openToast = function (message, severity, options) {
        if (options === void 0) { options = {}; }
        setisOpen(true);
        setToast(__assign({ message: message, severity: severity }, options));
    };
    var closeToast = React.useCallback(function () {
        setisOpen(false);
    }, []);
    return (React.createElement(ToastContext.Provider, { value: { openToast: openToast, closeToast: closeToast } },
        !!toast && (React.createElement(Toast, __assign({ open: isOpen }, toast, { onClose: closeToast, TransitionProps: { onExited: function () { return setToast(null); } } }))),
        children));
};
export var useToast = function () { return React.useContext(ToastContext); };
